import { EventType } from 'sports'

import moment from 'moment/moment'

import type { MatchSchema } from 'match'

export const BASE_URL = '/match'

export const REDUCER_INDEX = 'match_v2'

export const MATCH_MAX_MINUTES = 120

export const isMatchApproved = (match: { approved_at?: number }) => !!match.approved_at

export const isMatchDeferred = (match: { is_deferred?: boolean }) => !!match.is_deferred

export const isMatchEnded = (match: {
  approved_at?: number
  ended_at?: number
  is_deferred?: boolean
  matched_at?: number
  started_at?: number
}) => {
  const start = match.started_at || match.matched_at || 0
  if (start <= 0 || isMatchDeferred(match)) {
    return false
  }

  if (match.ended_at || isMatchApproved(match)) {
    return true
  }

  return start + MATCH_MAX_MINUTES * 60 < moment.utc().valueOf() / 1000
}

export const isMatchPlaying = (match: {
  approved_at?: number
  ended_at?: number
  is_deferred?: boolean
  matched_at?: number
  started_at?: number
}) => {
  const start = match.started_at || match.matched_at || 0
  if (start <= 0 || isMatchDeferred(match) || match.ended_at || isMatchApproved(match)) {
    return false
  }

  const now = moment.utc().valueOf() / 1000
  return start < now && start + MATCH_MAX_MINUTES * 60 > now
}

export const isMatchWaiting = (match: {
  approved_at?: number
  ended_at?: number
  is_deferred?: boolean
  matched_at?: number
  started_at?: number
}) => {
  const start = match.started_at || match.matched_at || 0

  if (start <= 0 || isMatchDeferred(match)) {
    return true
  }

  if (match.ended_at || isMatchApproved(match)) {
    return false
  }

  return start > moment.utc().valueOf() / 1000
}

export const getLocalGoals = (match: {
  approved_at?: number
  events: MatchSchema['events']
  local: MatchSchema['local']
  local_goals: number
  local_walkover?: boolean
}) => {
  if (isMatchApproved(match)) {
    return match.local_walkover ? 'W' : match.local_goals
  }

  let localScore = 0
  match.events.forEach((event) => {
    if (event.type.includes('GOAL')) {
      const isLocal = event.team.id === match.local.id
      if ((isLocal && event.type !== EventType.GOAL_AUTO) || (!isLocal && event.type === EventType.GOAL_AUTO)) {
        localScore += 1
      }
    }
  })

  return localScore
}

export const getVisitorGoals = (match: {
  approved_at?: number
  events: MatchSchema['events']
  visitor: MatchSchema['visitor']
  visitor_goals: number
  visitor_walkover?: boolean
}) => {
  if (isMatchApproved(match)) {
    return match.visitor_walkover ? 'W' : match.visitor_goals
  }

  let visitorScore = 0
  match.events.forEach((event) => {
    if (event.type.includes('GOAL')) {
      const isVisitor = event.team.id === match.visitor.id
      if ((isVisitor && event.type !== EventType.GOAL_AUTO) || (!isVisitor && event.type === EventType.GOAL_AUTO)) {
        visitorScore += 1
      }
    }
  })

  return visitorScore
}

export const getMatchDate = (match: { is_deferred?: boolean; matched_at?: number; started_at?: number }) => {
  if (isMatchDeferred(match)) {
    return 'Encuentro pospuesto'
  }
  const start = match.started_at || match.matched_at || 0
  return start > 0 ? moment.unix(start).format('dddd, DD [de] MMM H:mm [h]') : 'Sin fecha definida'
}
